import { PositionType } from 'data/types';
import { sanitizeEditedOutline } from 'utils/footprint-union';
import {
  boundsMaxDimension,
  orthogonalizeOutline,
  roundAndDedupe,
  simplifyPath
} from 'utils/freehand-outline-helpers';
import { polygonAreaAbs } from 'utils/space-gap-fill';

const MAX_SIMPLIFY_TOLERANCE_FEET = 1.5;
const SIMPLIFY_TOLERANCE_RATIO = 0.12;

export const MIN_DRAWN_AREA_SQFT = 16;

export {
  orthogonalizeOutline,
  simplifyPath
} from 'utils/freehand-outline-helpers';

export function freehandToFootprintShape(
  rawPoints: PositionType[],
  minAreaSqft: number = MIN_DRAWN_AREA_SQFT
): PositionType[] | null {
  if (rawPoints.length < 3) return null;

  const tolerance = Math.min(
    MAX_SIMPLIFY_TOLERANCE_FEET,
    boundsMaxDimension(rawPoints) * SIMPLIFY_TOLERANCE_RATIO
  );
  const simplified = simplifyPath(rawPoints, tolerance);
  if (simplified.length < 3) return null;

  const squared = orthogonalizeOutline(simplified);
  if (squared.length < 3) return null;

  const sanitized = sanitizeEditedOutline(squared);
  if (!sanitized) return null;

  const shape = roundAndDedupe(sanitized);
  if (shape.length < 3) return null;
  if (polygonAreaAbs(shape) < minAreaSqft) return null;

  return shape;
}
